$(document).ready(function(){
  
  global_js();
  
  if(link_checker('products') > 0){
  	product_page();
  }
})


const global_js = () =>{
  $(".menu-toggle-inner").click(function(){
    let this_elem = $(this);
    $(this).toggleClass("hidden");
    if(this_elem.hasClass('open_menu')){
      this_elem.addClass('close_menu');
      this_elem.removeClass('open_menu');
      $(".body-content").addClass('normal')
      $(".navigation-content").addClass('hidden');
    }else if(this_elem.hasClass('close_menu')){
      this_elem.addClass('open_menu');
      this_elem.removeClass('close_menu');
      $(".body-content").removeClass('normal')
      $(".navigation-content").removeClass('hidden');
    }

  });
}

const link_checker = (link) => {
	let selected_link = link;
    if(window.location.href.search(link) > 0){
		return true;
    }else{
    	return false;
    }
}


const product_page = () =>{
	$(".product-photo-container").slick("slickSetOption", "adaptiveHeight", true, false);
}